<template>
  <div class="settings-form">
    <loader v-if="loading" :fixed="false" :absolute="false" />

    <template v-else>
      <template v-if="useKeysMode">
        <v-row v-for="(v, i) in orderedRows" :key="`sfrow-${i}`">
          <v-col cols="9">
            <slot
              name="field"
              :row="v"
              :disabled="disabled || v.isDefaultValue"
              :on-input="emitInput"
              :settings="value"
            >
              <template v-if="v.type === 'boolean'">
                <v-checkbox
                  v-if="v.isDefaultValue"
                  v-model="v.defaultValue"
                  :label="v.name"
                  disabled
                />
                <v-checkbox
                  v-else
                  v-model="v.value"
                  :label="v.name"
                  :disabled="disabled"
                  @input="emitInput"
                />
              </template>
              <template v-else-if="v.type === 'select'">
                <v-select
                  v-if="v.isDefaultValue"
                  :value="v.defaultValue"
                  :items="v.options || []"
                  :label="v.name"
                  outlined
                  disabled
                />
                <v-select
                  v-else
                  v-model="v.value"
                  :items="v.options || []"
                  :label="v.name"
                  outlined
                  :disabled="disabled"
                  @input="emitInput"
                />
              </template>
              <template v-else-if="v.type === 'payment_methods_table'">
                <payment-by-delivery-relation-settings
                  v-show="v.isDefaultValue"
                  :value="v.defaultValue"
                  :online-payment-enabled="onlinePaymentEnabled"
                  disabled
                />
                <payment-by-delivery-relation-settings
                  v-show="!v.isDefaultValue"
                  v-model="v.value"
                  :online-payment-enabled="onlinePaymentEnabled"
                  :disabled="disabled"
                  @input="emitInput"
                />
              </template>
              <template v-else-if="v.type === 'printer_code_pages_table'">
                <printer-code-pages-settings
                  v-show="v.isDefaultValue"
                  :value="v.defaultValue"
                  :label="v.name"
                  disabled
                />
                <printer-code-pages-settings
                  v-show="!v.isDefaultValue"
                  v-model="v.value"
                  :label="v.name"
                  :disabled="disabled"
                  @input="emitInput"
                />
              </template>
              <template v-else-if="v.type === 'sound'">
                <sound-select-settings
                  v-if="v.isDefaultValue"
                  :value="v.defaultValue"
                  :label="v.name"
                  disabled
                />
                <sound-select-settings
                  v-else
                  v-model="v.value"
                  :label="v.name"
                  :disabled="disabled"
                  @input="emitInput"
                />
              </template>
              <template v-else>
                <v-text-field
                  v-show="v.isDefaultValue"
                  v-model="v.defaultValue"
                  :label="v.name"
                  outlined
                  disabled
                />
                <v-text-field
                  v-show="!v.isDefaultValue"
                  v-model="v.value"
                  :label="v.name"
                  outlined
                  :disabled="disabled"
                  @input="emitInput"
                />
              </template>
            </slot>
          </v-col>
          <v-col cols="3">
            <v-switch
              :input-value="v.isDefaultValue"
              label="По умолчанию"
              :disabled="disabled"
              @change="onToggleDefault(v)"
            />
          </v-col>
        </v-row>
      </template>

      <template v-else>
        <div
          v-for="(group, groupKey) in groupedRows"
          :key="`sfgroup-${groupKey}`"
          class="settings-form__group"
        >
          <div
            v-if="!hideGroupTitles"
            class="text-h3 settings-form__group-title"
            v-text="getGroupTitle(groupKey)"
          />
          <v-row v-for="(v, i) in group" :key="`sfgrow-${groupKey}-${i}`">
            <v-col cols="9">
              <slot
                name="field"
                :row="v"
                :disabled="disabled || v.isDefaultValue"
                :on-input="emitInput"
                :settings="value"
              >
                <template v-if="v.type === 'boolean'">
                  <v-checkbox
                    v-if="v.isDefaultValue"
                    v-model="v.defaultValue"
                    :label="v.name"
                    disabled
                  />
                  <v-checkbox
                    v-else
                    v-model="v.value"
                    :label="v.name"
                    :disabled="disabled"
                    @input="emitInput"
                  />
                </template>
                <template v-else-if="v.type === 'select'">
                  <v-select
                    v-if="v.isDefaultValue"
                    :value="v.defaultValue"
                    :items="v.options || []"
                    :label="v.name"
                    outlined
                    disabled
                  />
                  <v-select
                    v-else
                    v-model="v.value"
                    :items="v.options || []"
                    :label="v.name"
                    outlined
                    :disabled="disabled"
                    @input="emitInput"
                  />
                </template>
                <template v-else-if="v.type === 'payment_methods_table'">
                  <payment-by-delivery-relation-settings
                    v-show="v.isDefaultValue"
                    :value="v.defaultValue"
                    :online-payment-enabled="onlinePaymentEnabled"
                    disabled
                  />
                  <payment-by-delivery-relation-settings
                    v-show="!v.isDefaultValue"
                    v-model="v.value"
                    :online-payment-enabled="onlinePaymentEnabled"
                    :disabled="disabled"
                    @input="emitInput"
                  />
                </template>
                <template v-else-if="v.type === 'printer_code_pages_table'">
                  <printer-code-pages-settings
                    v-show="v.isDefaultValue"
                    :value="v.defaultValue"
                    :label="v.name"
                    disabled
                  />
                  <printer-code-pages-settings
                    v-show="!v.isDefaultValue"
                    v-model="v.value"
                    :label="v.name"
                    :disabled="disabled"
                    @input="emitInput"
                  />
                </template>
                <template v-else-if="v.type === 'sound'">
                  <sound-select-settings
                    v-if="v.isDefaultValue"
                    :value="v.defaultValue"
                    :label="v.name"
                    disabled
                  />
                  <sound-select-settings
                    v-else
                    v-model="v.value"
                    :label="v.name"
                    :disabled="disabled"
                    @input="emitInput"
                  />
                </template>
                <template v-else>
                  <v-text-field
                    v-show="v.isDefaultValue"
                    v-model="v.defaultValue"
                    :label="v.name"
                    outlined
                    disabled
                  />
                  <v-text-field
                    v-show="!v.isDefaultValue"
                    v-model="v.value"
                    :label="v.name"
                    outlined
                    :disabled="disabled"
                    @input="emitInput"
                  />
                </template>
              </slot>
            </v-col>
            <v-col cols="3">
              <v-switch
                :input-value="v.isDefaultValue"
                label="По умолчанию"
                :disabled="disabled"
                @change="onToggleDefault(v)"
              />
            </v-col>
          </v-row>
        </div>
      </template>
    </template>
  </div>
</template>

<script>
  import _ from 'lodash'
  import Loader from '@/components/loader/Loader.vue'
  import PaymentByDeliveryRelationSettings from '@/components/ui/crud/fields/filial-settings/PaymentByDeliveryRelationSettings.vue'
  import PrinterCodePagesSettings from '@/components/ui/crud/fields/filial-settings/PrinterCodePagesSettings.vue'
  import SoundSelectSettings from '@/components/ui/crud/fields/filial-settings/SoundSelectSettings.vue'
  import snackbarMessage from '@/mixins/snackbar-message'

  export default {
    name: 'SettingsForm',
    components: { Loader, PaymentByDeliveryRelationSettings, PrinterCodePagesSettings, SoundSelectSettings },
    mixins: [snackbarMessage],
    props: {
      value: { type: Array, default: () => [] },
      keys: { type: Array, default: null },
      category: { type: String, default: null },
      excludeKeys: { type: Array, default: () => [] },
      hideGroupTitles: { type: Boolean, default: false },
      createEntity: { type: Boolean, default: false },
      loading: Boolean,
      disabled: Boolean,
    },
    computed: {
      useKeysMode () {
        return Array.isArray(this.keys) && this.keys.length > 0
      },
      filteredRows () {
        let rows = this.value.slice()
        if (this.useKeysMode) {
          rows = rows.filter((r) => this.keys.includes(r.key))
        } else if (this.category) {
          rows = rows.filter((r) => r.group === this.category)
        }
        if (this.excludeKeys.length) {
          rows = rows.filter((r) => !this.excludeKeys.includes(r.key))
        }
        return rows
      },
      orderedRows () {
        if (!this.useKeysMode) return this.filteredRows
        const byKey = _.keyBy(this.filteredRows, 'key')
        return this.keys.map((k) => byKey[k]).filter(Boolean)
      },
      groupedRows () {
        const sorted = _.sortBy(this.filteredRows, ['group', 'sort'])
        return _.groupBy(sorted, 'group')
      },
      onlinePaymentEnabled () {
        const row = this.value.find((s) => s.key === 'onlinePaymentEnabled')
        if (!row) return true
        const val = row.isDefaultValue ? row.defaultValue : row.value
        return val === 1 || val === '1' || val === true || val === 'true'
      },
    },
    created () {
      if (this.createEntity) this.loadDefaultSettings()
    },
    methods: {
      async loadDefaultSettings () {
        try {
          let settings = await this.$store.dispatch('branchesSettings/fetchSettings', {
            limit: 10000,
            offset: 0,
            page: 1,
          })
          settings = settings.filter((item) => item.system !== true)
          this.$emit('input', settings)
        } catch (e) {
          this.showErrorFromResponse(e)
        }
      },
      getGroupTitle (groupKey) {
        if (groupKey && groupKey !== 'null') {
          return this.filteredRows.find((r) => r.group === groupKey)?.groupTitle || groupKey
        }
        return 'Разное'
      },
      onToggleDefault (row) {
        row.isDefaultValue = !row.isDefaultValue
        this.emitInput()
      },
      emitInput () {
        this.$emit('input', this.value)
      },
    },
  }
</script>

<style lang="less" scoped>
.settings-form {
  margin-bottom: 50px;

  &__group-title {
    color: #000;
    margin-bottom: 10px;
  }

  &__group {
    margin-bottom: 20px;

    &:last-child {
      margin-bottom: 0;
    }
  }
}
</style>
